<template>
  <!-- modal -->
  <div class="dimed">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.QrCodePay.msg1') }}</div>
        <div class="ft-point">{{ $t('Modal.QrCodePay.msg2') }}</div>
        <div class="lyr-txt">{{ $t('Modal.QrCodePay.msg3') }}</div>
      </div>
      <div class="layer__body">
        <img src="@/assets/images/user/artwork_popup_pay_3d.gif" alt="" class="img-size" />
      </div>
      <div class="layer__button">
        <button @mouseup="cancelPayment()" class="btn btn--line btn--xlg btn-anim">{{ $t('Modal.QrCodePay.msg4') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'qrCodePay',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      cancelYn: false,
      oneCallYn: false,
      posTransactionYn: false,
      tranUrl: '',
      text: '',
    };
  },
  mounted() {
    this.paymentEnd();
  },
  props: {
    totalUprc: Number,
    tran: Object,
  },
  methods: {
    paymentEnd() {
      let tranObj = {
        tranNo: this.tran.tranNo,
        orderNo: this.tran.orderNo,
        payType: this.tran.PAYMENTLIST[0].SETTLE_METHOD,
        totalUprc: this.totalUprc,
      };
      this.$emit('setPayComplete', tranObj);
    },

    async cancelPayment() {
      if (!this.cancelYn) {
        this.cancelYn = true;
        this.$store.dispatch('startIdle');
        this.$emit('closeQrCodePay');
      }
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  components: {
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/menu.css" scoped></style>
<style src="@/assets/css/user/pages/touchbox.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/menu-dark.css" scoped></style>
<style src="@/assets/css/user/dark/touchbox-dark.css" scoped></style>
<style scoped></style>
